module.exports = __webpack_public_path__ + "img/pszczola_active.75058013.svg";